import { Box, Grid, Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import { IAddressBookData } from '../../../../../models';

import { Contacts } from '@mui/icons-material';
import { Card, Loader, Table } from '../../../../../components';

interface IAddressBookList {
  buildId: string;
  isLoading: boolean;
  addressBook: IAddressBookData[];
  refetchAddressBook: () => void;
}
export const AddressBookList: FC<IAddressBookList> = ({
  buildId,
  isLoading,
  addressBook,
  refetchAddressBook
}) => {
  const columns = useMemo(() => {
    return [
      {
        Header: 'Role',
        accessor: 'relationship',
        sort: true
      },
      {
        Header: 'Contact',
        accessor: 'displayValue',
        sort: true
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addressBookTableData = useMemo(() => {
    return addressBook?.reduce((acc, curr) => {
      if (curr.displayValues?.length === 0) {
        acc.push({
          relationship: curr.relationship,
          displayValue: 'No Contact'
        });
      }
      curr?.displayValues?.forEach(displayValue => {
        acc.push({
          relationship: curr.relationship,
          displayValue: displayValue
        });
      });
      return acc;
    }, []);
  }, [addressBook]);

  return (
    <Box mt={1}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          {isLoading && (
            <Box
              mt={1}
              minHeight="30rem"
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              <Loader type="inline" position="centered">
                Loading...
              </Loader>
            </Box>
          )}
          {addressBook?.length > 0 ? (
            <Card icon={<Contacts />} title="Contacts">
              <Table
                columns={columns}
                data={addressBookTableData}
                isLoading={isLoading}
                hidePagination
              />
            </Card>
          ) : (
            !isLoading && <Typography variant="body1">No Contacts</Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
